"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusActionInput = void 0;
const react_1 = __importStar(require("react"));
require("./BonusActionInput.scss");
const BonusActionInput_scss_json_1 = __importDefault(require("./BonusActionInput.scss.json"));
const package_1 = require("../package");
const Topic_1 = require("../shapes/Topic");
const Button_1 = require("lincd-mui-base/lib/components/Button");
const Modal_1 = require("lincd-mui-base/lib/components/Modal");
const react_select_1 = __importDefault(require("react-select"));
const InputField_1 = require("lincd-input/lib/components/InputField");
const ActionTemplate_1 = require("../shapes/ActionTemplate");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
const react_2 = require("@tolgee/react");
exports.BonusActionInput = (0, package_1.linkedComponent)(Topic_1.Topic, ({ source, onSelected, selected, quantity, previousBonusActions, onQuantityChanged, }) => {
    var _a;
    const bonus = (_a = source.actionTemplates) === null || _a === void 0 ? void 0 : _a.filter((action, i) => Boolean(action.isBonus));
    const { t } = (0, react_2.useTranslate)();
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const [actionNameFilled, setActionNameFilled] = (0, react_1.useState)(false);
    const [customTemplate, setCustomTemplate] = (0, react_1.useState)(null);
    const [selectCounter, setSelectCounter] = (0, react_1.useState)(0);
    const setSelectedTemplate = (template) => {
        onSelected(template);
        //if the user did not fill in a quantity already, we set it to 1 when they select an option
        if (!quantity || quantity < 0) {
            onQuantityChanged(1);
        }
        if (quantity > 10) {
            onQuantityChanged(10);
        }
    };
    const onOptionSelected = (option) => {
        //we have access to option.value, option.label
        if (option.value === 'add_your_own') {
            setShowModal(true);
        }
        else {
            //update the SelectedTemplate using ActionTemplate that has the same URI
            setSelectedTemplate(ActionTemplate_1.ActionTemplate.getFromURI(option.value));
        }
    };
    const onToggleModal = () => {
        setShowModal(!showModal);
    };
    const addPeaceAction = () => {
        if (peaceActionValue.actionName == '') {
            setActionNameFilled(true);
            return;
        }
        else {
            const customTemplate = ActionTemplate_1.ActionTemplate.create({
                name: peaceActionValue.actionName,
                description: peaceActionValue.description,
                isCustom: true,
                isBonus: true,
                points: 1,
            });
            customTemplate.save();
            setCustomTemplate(customTemplate);
            setSelectedTemplate(customTemplate);
            setShowModal(false);
        }
    };
    let arrayOfBonuses = [];
    const [peaceActionValue, setPeaceActionValue] = (0, react_1.useState)({
        actionName: '',
        description: '',
    });
    arrayOfBonuses = source.actionTemplates
        .filter((action) => action.isBonus)
        .map((action) => {
        return actionTemplateToOption(action, t);
    });
    //add the previous bonus actions to the array, after converting them to options
    if (previousBonusActions) {
        arrayOfBonuses = arrayOfBonuses.concat(previousBonusActions.map((action) => actionTemplateToOption(action, t)));
    }
    //if user filled in custom option
    if (customTemplate) {
        arrayOfBonuses.push(actionTemplateToOption(customTemplate, t));
    }
    arrayOfBonuses.push({
        value: 'add_your_own',
        label: (react_1.default.createElement("span", { className: BonusActionInput_scss_json_1.default.addYourOwnPeaceAction, onClick: () => setShowModal(true) }, t('word.addYourOwn', 'Add your own... +'))),
    });
    // }
    return (react_1.default.createElement("div", { className: BonusActionInput_scss_json_1.default.BonusActionInput },
        react_1.default.createElement("div", { className: BonusActionInput_scss_json_1.default.bonusPoints },
            react_1.default.createElement("label", null, t('word.bonus', 'Bonus')),
            react_1.default.createElement(InputField_1.InputField, { maxLength: 2, value: !isNaN(quantity) && quantity > 0
                    ? quantity > 10
                        ? '10'
                        : quantity.toString()
                    : '', onChange: (e) => onQuantityChanged(e.target.value), className: BonusActionInput_scss_json_1.default.bonusInput, "aria-label": t('bonusActionInput.quantity', 'Quantity') })),
        react_1.default.createElement(react_select_1.default, { key: selectCounter.toString(), options: bonus && arrayOfBonuses, isOptionSelected: (option) => {
                return option.value === (selected === null || selected === void 0 ? void 0 : selected.uri);
            }, formatOptionLabel: (option, { context }) => {
                //This is bug fix, when the user clicks on add your own we change
                //the options, but select thinks add your own is still selected
                //so we render the right title in this case
                if (context === 'menu') {
                    return (react_1.default.createElement("div", { className: BonusActionInput_scss_json_1.default.selectOptionListItem },
                        react_1.default.createElement("h3", null, option.label),
                        option.description && react_1.default.createElement("p", null, option.description)));
                }
                else if (context === 'value') {
                    return react_1.default.createElement("span", null, selected ? selected.name : option.label);
                }
                // if (
                //   selected &&
                //   selected.isCustom &&
                //   option.value === 'add_your_own'
                //   && option.description
                // ) {
                //   return <span>{selected.name}</span>;
                // }
                // if (
                //   selected &&
                //   selected.isCustom &&
                //   option.value === 'add_your_own'
                // ) {
                //   return <span>{selected.name}</span>;
                // }
                // return <span>{option.label}</span>;
            }, defaultValue: selected ? selected === null || selected === void 0 ? void 0 : selected.uri : customTemplate ? customTemplate === null || customTemplate === void 0 ? void 0 : customTemplate.uri : '', defaultInputValue: selected ? selected === null || selected === void 0 ? void 0 : selected.uri : customTemplate ? customTemplate === null || customTemplate === void 0 ? void 0 : customTemplate.uri : '', className: BonusActionInput_scss_json_1.default.select, onChange: onOptionSelected, "aria-label": t('bonusActionInput.select', 'Select bonus action') }),
        react_1.default.createElement(Modal_1.Modal, { isOpen: showModal, backdrop: "rgba(0, 0, 0, 0.8)", onClose: onToggleModal },
            react_1.default.createElement("div", { className: BonusActionInput_scss_json_1.default.actionModal },
                react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/close_button.svg'), className: BonusActionInput_scss_json_1.default.closeButton, onClick: () => setShowModal(false), "aria-label": t('bonusActionInput.close', 'Close') }),
                react_1.default.createElement("h3", null, t('bonusActionInput.addYourAction', 'Add Your Peace Action')),
                react_1.default.createElement("label", null, t('bonusActionInput.actionName', 'Action Name').toUpperCase()),
                react_1.default.createElement(InputField_1.InputField, { maxLength: 30, onChange: (e) => {
                        setActionNameFilled(false);
                        setPeaceActionValue(Object.assign(Object.assign({}, peaceActionValue), { actionName: e.target.value }));
                    }, helperText: actionNameFilled &&
                        t('bonusActionInput.actionNameRequired', 'Please fill in an action name!'), "aria-label": t('bonusActionInput.actionName', 'Action Name') }),
                react_1.default.createElement("label", null, t('bonusActionInput.shortDescription', 'Short Description').toUpperCase()),
                react_1.default.createElement(InputField_1.InputField, { maxLength: 180, className: BonusActionInput_scss_json_1.default.textArea, multiline: true, onChange: (e) => {
                        setPeaceActionValue(Object.assign(Object.assign({}, peaceActionValue), { description: e.target.value }));
                    }, "aria-label": t('bonusActionInput.shortDescription', 'Short Description') }),
                react_1.default.createElement(Button_1.Button, { variant: "outlined", fullWidth: false, className: BonusActionInput_scss_json_1.default.addButton, onClick: addPeaceAction }, t('bonusActionInput.addAction', 'Add')),
                react_1.default.createElement("p", { className: BonusActionInput_scss_json_1.default.note }, t('bonusActionInput.note', 'When creating a Peace Action make sure that it meets or exceeds the current actions in this category. Assign your new action the value of 1 Peace Action. (We will be reviewing all bonus actions and adding some to the bonus section for all players.)'))))));
});
function actionTemplateToOption(action, t) {
    return {
        value: action.uri,
        description: action.description &&
            t(action.identifier + '.description', action.description),
        label: t(action.identifier + '.name', action.name.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())),
    };
}
//register all components in this file
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=BonusActionInput.js.map